import React from 'react';

import { ChildrenProps, cn } from '../../../../../utils';
import { ClassNameDecorator } from '../../../../decorators';
import { ClassInjector } from '../../../../injectors';

import './TertiaryButton.scoped.scss';

export enum TertiaryButtonColor {
  GREEN = 'tertiary-button--green',
  GRAY = 'tertiary-button--gray',
  WHITE = 'tertiary-button--white',
  WHITE_GREEN = 'tertiary-button--white-green',
}

interface Props extends ChildrenProps {
  color: TertiaryButtonColor;
  expanded?: boolean;
  large?: boolean;
}

const TertiaryButton: ClassNameDecorator<Props> = ({
  color,
  children,
  expanded,
  large,
  className,
}) => {
  return (
    <ClassInjector
      classNames={cn(
        'tertiary-button',
        `${color}`,
        `${expanded ? 'tertiary-button--expanded' : ''}`,
        `${large ? 'tertiary-button--large' : ''}`
      )}
      oldClassName={className}
    >
      {children}
    </ClassInjector>
  );
};

export default TertiaryButton;
